/**
 * @desc 退货单商品详情
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.RejectBillOperationDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/rejectBillItemList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
